import React from "react";
import "components/Feeds/Feeds.css";
import DefaultProfilePic from "site_media/images/default-profile-pic-feeds.png";

/**
 * @description Displays the goal set by a friend for user's project.
 * @class FriendSetGoal
 * @implements none
 * @extends React.Component
 * @type {FriendSetGoal}
 * @example <FriendSetGoal />
 * pre-condition: all the imports
 * post-condition: returns a form with the information about a friend setting a goal for user's project.
 * @param profilePic, friendsName, projectName, goalName, time
 * @returns {FriendSetGoal}
 */

class FriendSetGoal extends React.Component {
  
  render() {
  
    let event = new Date(this.props.time);
    const formattedDate = Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).format(event);
    const time = event.toLocaleTimeString("en-US");
    let goal_date = new Date(this.props.goalDate);
    goal_date.setTime(goal_date.getTime() + (goal_date.getTimezoneOffset() * 60 * 1000));
    const formattedGoalDate = Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).format(goal_date);
    return (
      <div className="feed-wrapper">
        <div className="feed-form">
          <p className="mobile-profile-pic">
            <img
              alt="mobile-profile-pic"
              className="profile-pic"
              src={this.props.profilePic || DefaultProfilePic}
            />
          </p>
          <p className="mobile-intro">
            <label style={{ fontWeight: "bold" }}>
              {this.props.friendsName}
            </label>
            <label>
              {this.props.friendsName} set a project impact goal on{" "}
              {formattedDate}, {time}
            </label>
          </p>
        </div>
        <div className="feed-display-adjacent">
          <p>
            <img
              className="display-pic-adjacent"
              alt="profile-pic"
              src={this.props.profilePic || DefaultProfilePic}
            />
          </p>
          <p>
            <img
              className="display-pic-adjacent"
              alt="project-badge"
              src={this.props.projectBadge}
            />
          </p>
        </div>
        <div className="feed-form">
          <label>{this.props.friendsName} just set a goal <i>{this.props.goalName}</i> for the impact project <i>{this.props.projectName}</i>, to be completed by <i>{formattedGoalDate}</i>.</label>
        </div>
      </div>
    );
  }
}

export default FriendSetGoal;
